import React from "react";
import { FaPhone } from "react-icons/fa";
import $ from "jquery";
export default class Services extends React.Component {
  state = {
    isMounted: false
  };

  componentDidMount() {
    setTimeout(
      function () {
        this.setState(prevState => ({ isMounted: !prevState.isMounted }));
      }.bind(this),
      0
    );
  }

  handleTelsent = () => {
    $(".call-input-container").fadeOut(300);
  };
  render() {
    return (
      <div className="services-wrapper">
        <div className="scroll-downs">
          <div className="mousey">
            <div className="scroller" />
          </div>
        </div>
        {/* mobile and tablet */}
        <h2 className="services-title" id="services">
          Služby
        </h2>
        <div className="stolek-container" id="services" />
        <div className="services-grid">
          <div className="services-text-container desktop">
            <p
              className={
                this.state.isMounted ? "services-text" : "services-text"
              }
            >
              Naše rodinná firma se zabývá zakázkovou výrobou nábytku. Nejčastěji připravujeme kompletní vybavení kuchyní a obývacích místností. Rádi pro vás však navrhneme a vyrobíme i jednotlivé kusy jako skříně, stoly, židle či postele. Nezalekneme se ani větších projektů, kterými jsou třeba hotelová recepce nebo vybavení restaurace. Během konzultace spolu určitě něco vymyslíme.
              <br />
              <span>Stavte se na kafe!</span>
            </p>
          </div>
          {/* zrcadlo */}
          <div className="picture-container" />
        </div>

        <div className="ste konzultace">
          <h3 className="services-subtitle">Konzultace a návrh</h3>
          <p className="services-text">
            Nejprve si upřesníme společný cíl. Zpracujeme vizualizaci výsledné podoby, abychom měli jasno a mohli začít.
          </p>
        </div>

        {/* stolek */}
        <div className="hala-container" />

        <div className="ste notdesktop">
          <h3 className="services-subtitle">Výroba a montáž</h3>
          <p className="services-text">
            Jakmile máme jasno v tom, co si přejete, v naší dílně vše vyrobíme a připravíme. Hotový nábytek u vás poté nainstalujeme a doladíme. Jako bonus přidáváme <span>mnohaletou záruku</span>.
          </p>
        </div>
        <div className="hala2-container tablet notdesktop" />

        {/* konec mobile a tablet */}

        <div className="services-grid2" id="cislo">
          <div className="hala2-container desktop" id="services" />

          <div className="ste">
            <h3 className="services-subtitle">Výroba a montáž</h3>
            <p className="services-text">
              Jakmile máme jasno v tom, co si přejete, v naší dílně vše vyrobíme a připravíme. Hotový nábytek u vás poté nainstalujeme a doladíme. Jako bonus přidáváme <span>mnohaletou záruku</span>.
            </p>
          </div>
          <div className="hala2-container tablet" />

          <div className="background">
            <div className="call-container">
              <div className="call-title-container">
                <h2 className="call-title">Zavoláme Vám!</h2>

                <FaPhone className="FaPhone" />
              </div>
              <form
                className="call-input-container"
                action="getmail.php"
                method="post"
              >
                <div className="call-inputt">
                  <input
                    className="call-input"
                    type="number"
                    name="tel"
                    placeholder="Vaše tel. číslo"
                  />
                </div>
                <div className="call-btnn">
                  <button
                    onClick={this.handleTelsent}
                    className="call-btn"
                    name="submit"
                    type="submit"
                  >
                    Odeslat
                  </button>
                </div>
              </form>
              <p className="call-contact">Dušan Baťka — 777 338 077</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Services.js